module.exports = __webpack_public_path__ + "img/18775.86c98874.png";